// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lrpad-mob0-desk12 {
    padding-left: 12px;
    padding-right: 12px;
}
button:disabled{
    cursor:not-allowed !important;
    background-color: #dee2e6;
    color: #242424 !important;
  }
@media screen and (max-width: 999px) {
    .lrpad-mob0-desk12 {
        padding-left: 0px;
        padding-right: 0px;
    }
}
.right-border {
    border-right: solid 1px #dee2e6;
}`, "",{"version":3,"sources":["webpack://./src/modules/home/Home.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,yBAAyB;EAC3B;AACF;IACI;QACI,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;AACA;IACI,+BAA+B;AACnC","sourcesContent":[".lrpad-mob0-desk12 {\n    padding-left: 12px;\n    padding-right: 12px;\n}\nbutton:disabled{\n    cursor:not-allowed !important;\n    background-color: #dee2e6;\n    color: #242424 !important;\n  }\n@media screen and (max-width: 999px) {\n    .lrpad-mob0-desk12 {\n        padding-left: 0px;\n        padding-right: 0px;\n    }\n}\n.right-border {\n    border-right: solid 1px #dee2e6;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
